<div>
  <app-detalle-precios></app-detalle-precios>
</div>
